import React from 'react';

export const LazySubscribeHeader = React.lazy(() =>
  import(/* webpackChunkName: "subscribe" */ './SubscribeHeader'),
);
